module.exports = __webpack_public_path__ + "img/stripe.99828a4f.jpg";